import { type ReactNode } from "react"
import { ApiProvider } from "@krakentech/blueprint-api/client"
import { useKrakenAuthErrorHandler, useSession } from "@/lib/blueprint-auth/client"
import { apiRoutesPaths } from "@/routes/api"

// We need to wrap the `ApiProvider` in a component so that we can access hooks like `useConfig` and `useSession`.
export const CustomApiProvider = ({ children }: { children: ReactNode }) => {
    const { data: sessionState } = useSession()
    const { handleKrakenErrors } = useKrakenAuthErrorHandler()

    return (
        <ApiProvider
            apiRoute={apiRoutesPaths.graphql.kraken.resolve()}
            sessionState={sessionState}
            handleKrakenErrors={handleKrakenErrors}
        >
            {children}
        </ApiProvider>
    )
}
